var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 18.9",
    style: {
      enableBackground: "new 0 0 20.3 18.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,18.7c-0.1,0-0.2,0-0.3,0c-1.5,0-3.1,0-4.6,0c-1.3,0-2.3-0.9-2.3-2.3c0-1.9,0-3.8,0-5.6 c0-1.3,0.9-2.2,2.2-2.2c0.5,0,1,0,1.5,0c0.1,0,0.2,0,0.2,0.2c1.1,3.3,2.1,6.5,3.2,9.8C9.4,18.6,9.4,18.6,9.4,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,18.7c0.4-1.2,0.7-2.3,1.1-3.4c0.7-2.2,1.4-4.4,2.1-6.5c0.1-0.2,0.1-0.2,0.3-0.2c0.4,0,0.9,0,1.3,0 c1.1-0.1,2.3,0.7,2.3,2.3c0,1.9,0,3.8,0,5.6c0,1.3-0.9,2.2-2.3,2.2c-1.6,0-3.1,0-4.7,0C10.7,18.7,10.6,18.7,10.5,18.7z M14.7,15.4 C14.7,15.4,14.7,15.4,14.7,15.4c0.4,0,0.9,0,1.3,0c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.1-0.3-0.4-0.3c-0.9,0-1.7,0-2.6,0 c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.4,0.3C13.8,15.4,14.2,15.4,14.7,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,4.5c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C7.8,8.5,6,6.7,6,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,16.7c-0.1-0.2-0.1-0.3-0.2-0.5c-0.6-1.8-1.2-3.6-1.7-5.3c0-0.1,0-0.2,0.1-0.3c0.6-0.5,1.1-0.9,1.7-1.4 c0,0,0.1-0.1,0.1-0.1c0.6,0.5,1.2,1,1.9,1.6c0,0,0.1,0.1,0,0.2C11.2,12.8,10.6,14.7,9.9,16.7C10,16.7,10,16.7,9.9,16.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentManagement);
export default __webpack_public_path__ + "static/media/agent-management.92d8db0a8ac248acdfd96eff3d5ae0c6.svg";
export { ForwardRef as ReactComponent };